import { SET_AUDIO_INPUT_DEVICE } from "./actionTypes";
/**
 * Signals to update the currently used audio input device.
 *
 * @param {string} deviceId - The id of the new audio input device.
 * @returns {{
*      type: SET_AUDIO_INPUT_DEVICE,
*      deviceId: string
* }}
*/
export function setAudioInputDevice(deviceId) {
    return {
        type: SET_AUDIO_INPUT_DEVICE,
        deviceId
    };
}
